<template>
  <div class="flex align-items justify-content-center">
    <el-upload
        class="avatar-uploader"
        :action="action"
        accept="image/jpeg,image/png"
        multiple
        :show-file-list="false"
        :on-success="handleAvatarSuccess"
        :before-upload="beforeAvatarUpload">
      <i class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      action: this.actionUrl
    };
  },
  methods: {
    handleAvatarSuccess(res, file) {
      // const resultImg = URL.createObjectURL(file.raw);
      if(res.code === 200){
        this.$emit('upload', res.data.path);
      }else{
        this.$message.error(res.msg)
      }
    },
    beforeAvatarUpload(file) {
      const isImg = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif';
      const isLt2M = file.size / 1024 / 1024 < 20;

      if (!isImg) {
        this.$message.error('上传图片格式错误!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 20MB!');
      }
      return isImg && isLt2M;
    }
  }
}
</script>

<style scoped>
/deep/.avatar-uploader{
  width: 148px;
  height: 148px;
}
/deep/.avatar-uploader .el-upload {
  width: 148px;
  height: 148px;
  border: 1px dashed #d9d9d9;
  box-sizing: border-box;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
/deep/.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
/deep/.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}
</style>